import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/agents_enum";
import { useUpdateAgent, useSingleAgent } from "../../shared/hooks/UseAgent";
import { useSelectAllClient } from "../../shared/hooks/UseClient";
import { useSelectAllCentre } from "../../shared/hooks/UseCentre";
import { useSelectAllTeams } from "../../shared/hooks/UseTeam";
import { useSelectAllAgent } from "../../shared/hooks/UseAgent";
const EditAgent = ({ match }) => {
  let history = useHistory();
  const [data] = useSingleAgent(match.params.id);
  const [updateData] = useUpdateAgent();
  const { loading, agent } = data;
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const [client] = useSelectAllClient();
  const [centre] = useSelectAllCentre();
  const [team] = useSelectAllTeams();
  const [managers] = useSelectAllAgent();
  const [dropdownOptions, setDropdownOptions] = useState(null);
  const submitFormClicked = async (values) => {
    await updateData(agent._id, values);

    history.push(`/${LINK_URL}/${agent._id}/view`);
  };
  useEffect(() => {
    if (client && client.all_clients) {
      const newData = client.all_clients.map((item) => {
        return { label: item.name, value: item._id };
      });

      setDropdownOptions({ ...dropdownOptions, client: newData });
    }
  }, [client]);
  useEffect(() => {
    if (team && team.all_teams) {
      const newData = team.all_teams.map((item) => {
        return { label: item.name, value: item._id };
      });

      setDropdownOptions({ ...dropdownOptions, team: newData });
    }
  }, [team]);
  useEffect(() => {
    if (managers && managers.all_agents) {
      const newData = managers.all_agents.map((item) => {
        return { label: `${item.name} (${item.role})`, value: item._id };
      });

      setDropdownOptions({ ...dropdownOptions, reporting_manager: newData });
    }
  }, [managers]);
  useEffect(() => {
    if (centre && centre.all_centres) {
      const newData = centre.all_centres.map((item) => {
        return { label: item.name, value: item._id };
      });
      setDropdownOptions({ ...dropdownOptions, centre: newData });
    }
  }, [centre]);

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              agent && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {agent[Object.keys(inputFields)[0]]} - <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link
                          to={`/${LINK_URL}`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-angle-left"></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${agent._id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={agent}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAgent;
